import { useMemo } from 'react';
import { View } from 'react-native';

import { InlineAlert } from '@fhs/ui';
import { useCartContext } from '@fhs-legacy/frontend/src/state/cart';
import { selectors, useAppSelector } from '@fhs-legacy/frontend/src/state/global-state';
import { IAppliedRewards } from '@fhs-legacy/frontend/src/state/loyalty/hooks/types';
import { CHECKOUT_SAVINGS_BANNER } from '@fhs-legacy/frontend/src/utils/test-ids';

import { useOfferValidation } from '../cart-components/offer-item/use-offer-validation';
import SavingsWithOffer from '../savings-with-offer';

export default function CheckoutSavingsBanner() {
  const { serverOrder, serverOrderLoading } = useCartContext();

  const discountAmount = useMemo(() => {
    const discounts = serverOrder?.cart?.discounts || [];
    return discounts.reduce((sum, d) => sum + d.value, 0);
  }, [serverOrder?.cart?.discounts]);

  const selectedOffer = useAppSelector(selectors.loyalty.selectSelectedOffer);
  const appliedLoyaltyRewards: IAppliedRewards = useAppSelector(
    selectors.loyalty.selectAppliedLoyaltyRewards
  );

  const hasAnyRewardApplied = Object.values(appliedLoyaltyRewards).some(
    reward => reward?.timesApplied > 0
  );

  const { isValid, textOfferRequirementsNotMet } = useOfferValidation({
    selectedOffer,
  });

  if (!isValid) {
    return <InlineAlert type="error" message={textOfferRequirementsNotMet} />;
  }

  if (discountAmount === 0) {
    return null;
  }

  if (selectedOffer || hasAnyRewardApplied) {
    return (
      <View testID={CHECKOUT_SAVINGS_BANNER}>
        <SavingsWithOffer savings={discountAmount} loadingSavings={serverOrderLoading} />
      </View>
    );
  } else {
    return null;
  }
}
